import { getChainDisplayName, shortenAddress } from '@lib/utils';
import { Wallet } from '@types';
import React, { useState } from 'react';
import WalletIcon from '@components/WalletIcon';
import Button from './Button';
import useWallets from '@hooks/useWallets';
import OutsideClickHandler from 'react-outside-click-handler';
import useGenericPopup from '@hooks/useGenericPopup';
import Icon from './Icon';

interface ConnectedWalletProps {
  wallet: Wallet;
}

const ConnectedWallet = ({ wallet }: ConnectedWalletProps) => {
  const { type, address, chain, active } = wallet;
  const { disconnect } = useWallets();
  const { showWrongNetworkPopup, isOpen: isPopupOpen } = useGenericPopup();

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <OutsideClickHandler
      disabled={!isMenuOpen || isPopupOpen}
      onOutsideClick={(): void => setIsMenuOpen(false)}
    >
      <div className="relative">
        {active ? (
          <Button size="small" onClick={() => setIsMenuOpen((v) => !v)}>
            <WalletIcon
              className="text-iconSmall"
              variant={type}
              idPrefix="connected-wallet"
            />
            <span className="text-white text-smallRegular font-normal mx-1">
              {shortenAddress(address)}
            </span>
            <span className="flex items-center bg-white text-black text-micro font-normal px-1.5 h-[22px] rounded-full">
              {getChainDisplayName(chain)}
            </span>
          </Button>
        ) : (
          <Button
            variant="danger"
            size="small"
            onClick={() => {
              setIsMenuOpen((v) => !v);
              showWrongNetworkPopup();
            }}
          >
            <Icon.Network className="text-iconMedium mr-1" />
            Wrong Network
          </Button>
        )}
        {isMenuOpen && (
          <div className="absolute w-full mt-1 z-dropdown">
            <Button
              className="relative w-full justify-center"
              onClick={() => disconnect(wallet)}
            >
              Disconnect
            </Button>
          </div>
        )}
      </div>
    </OutsideClickHandler>
  );
};

export default ConnectedWallet;
